module.exports = __webpack_public_path__ + "img/otofuda_title.e50ca12e.png";